import React, { useEffect, useState } from "react";
import { fetchSheets } from "../api.js";

export default function RamadanNamesView() {
  const [sheets, setSheets] = useState([]);

  useEffect(() => {
    fetchSheets().then(setSheets);
  }, []);
  const [isVisible1, setIsVisible1] = useState(true);

  useEffect(() => {
    const intervalId = setInterval(() => {
      setIsVisible1((prevIsVisible) => !prevIsVisible);
    }, 1000); // Toggle visibility every 500ms

    return () => clearInterval(intervalId); // Cleanup on unmount
  }, []);
  // console.log(sheets && sheets[0]?.names[0]);
  // console.log(sheets && sheets[0]?.phones[29]);
  return (
    <>
      <div>
        {/* <h2>View Contacts</h2> */}
        {/* {sheets.map((sheet) => (
          <div key={sheet._id}>
            <div>
              <strong>Sheet:</strong> {sheet._id}
            </div>
            {Array.from({ length: 30 }).map((_, i) => (
              <div key={i}>
                <span>
                  #{i + 1} Name: {sheet.names[i] || ""}
                </span>{" "}
                <span>Phone: {sheet.phones[i] || ""}</span>
              </div>
            ))}
          </div>
        ))} */}
      </div>

      <div>
        <h1
          style={{
            textAlign: "center",
            marginTop: "-1px",
          }}
        >
          Middletown Islamic Center (NEW YORK)
        </h1>
        <h2
          style={{
            textAlign: "center",
            marginTop: "-25px",
            fontSize: "28px",
            marginBottom: "1px",
          }}
        >
          Ramadan | 2026 | 1447 | Subject to Moon Sighting
        </h2>
        {/* <br /> */}
        <h2
          style={{
            color: "red",

            textAlign: "center",
            marginTop: "-5px",
            fontSize: "28px",
            marginBottom: "1px",
          }}
        >
          <span
            style={{
              color: "red",
              fontSize: "25px",
              color: "#57595B",
              opacity: isVisible1 ? 1 : 0, // Control visibility with opacity
              transition: "opacity 0.2s ease-in-out", // Smooth transition for blinking
            }}
          >
            If you wish to host Iftar please contact brother:{" "}
          </span>
          <span
            style={{
              textAlign: "center",
              marginTop: "-1px",
              fontSize: "22px",
              color: "#1B3C53",
              // marginBottom: "-6px",
            }}
          >
            AKHTAR ALI (845.520.1311)
          </span>
        </h2>
        <table className="custom-table">
          {/* <thead>
            <tr>
              <th>Column 1</th>
              <th>Column 2</th>
              <th>Column 3</th>
              <th>Column 4</th>
            </tr>
          </thead> */}
          <tbody>
            {/* {rows.map((row, i) => (
              <tr key={i}>
                {row.map((cell, j) => (
                  <td key={j}>{cell}</td>
                ))}
              </tr>
            ))} */}
            <tr>
              <td
                style={{
                  // width: 400,
                  // height: 30,
                  // border: "1px solid #ccc",
                  textAlign: "center",
                  verticalAlign: "middle",
                  borderRadius: "25%",
                  // fontSize: 14,
                  cursor: "pointer",
                  transition: "0.2s",
                  fontFamily: "Stack Sans Headline, sans-serif",
                  background:
                    sheets && sheets[0]?.names[0] ? "#8CE4FF" : "#F08787",
                  // transform: "scale(1.03)",
                }}
              >
                <b style={{ fontSize: "25px", color: "#57595B" }}>
                  Ramadan{" "}
                  <span
                  // style={{
                  //   backgroundColor: "#000",
                  //   borderRadius: "50%",
                  //   width: "35px",
                  //   height: "35px",
                  //   display: "inline-block",
                  //   color: "#ffffffff",
                  // }}
                  >
                    1
                  </span>
                  <br />
                </b>{" "}
                <span style={{ fontSize: "18px", color: "#57595B" }}>
                  February 17 | Tuesday
                </span>
                <br />
                <span style={{ fontSize: "22px", fontWeight: "bold" }}>
                  {sheets && sheets[0]?.names[0]
                    ? `${sheets[0]?.names[0]} | ${sheets[0]?.phones[0]}`
                    : "Available!"}
                  {/* {sheets && sheets[0]?.names[29]} |
                  {sheets && sheets[0]?.phones[29]} */}
                </span>
              </td>
              <td
                style={{
                  // width: 400,
                  // height: 30,
                  // border: "1px solid #ccc",
                  textAlign: "center",
                  verticalAlign: "middle",
                  borderRadius: "25%",
                  // fontSize: 14,
                  cursor: "pointer",
                  transition: "0.2s",
                  fontFamily: "Stack Sans Headline, sans-serif",
                  background:
                    sheets && sheets[0]?.names[8] ? "#8CE4FF" : "#F08787",
                  // transform: "scale(1.03)",
                }}
              >
                <b style={{ fontSize: "25px", color: "#57595B" }}>
                  Ramadan 9 <br />
                </b>{" "}
                <span style={{ fontSize: "18px", color: "#57595B" }}>
                  February 17 | Tuesday
                </span>
                <br />
                <span style={{ fontSize: "22px", fontWeight: "bold" }}>
                  {sheets && sheets[0]?.names[8]
                    ? `${sheets[0]?.names[8]} | ${sheets[0]?.phones[8]}`
                    : "Available!"}
                  {/* {sheets && sheets[0]?.names[29]} |
                  {sheets && sheets[0]?.phones[29]} */}
                </span>
              </td>
              <td
                style={{
                  // width: 400,
                  // height: 30,
                  // border: "1px solid #ccc",
                  textAlign: "center",
                  verticalAlign: "middle",
                  borderRadius: "25%",
                  // fontSize: 14,
                  cursor: "pointer",
                  transition: "0.2s",
                  fontFamily: "Stack Sans Headline, sans-serif",
                  background:
                    sheets && sheets[0]?.names[16] ? "#8CE4FF" : "#F08787",
                  // transform: "scale(1.03)",
                }}
              >
                <b style={{ fontSize: "25px", color: "#57595B" }}>
                  Ramadan 17 <br />
                </b>{" "}
                <span style={{ fontSize: "18px", color: "#57595B" }}>
                  February 17 | Tuesday
                </span>
                <br />
                <span style={{ fontSize: "22px", fontWeight: "bold" }}>
                  {sheets && sheets[0]?.names[16]
                    ? `${sheets[0]?.names[16]} | ${sheets[0]?.phones[16]}`
                    : "Available!"}
                  {/* {sheets && sheets[0]?.names[29]} |
                  {sheets && sheets[0]?.phones[29]} */}
                </span>
              </td>
              <td
                style={{
                  // width: 400,
                  // height: 30,
                  // border: "1px solid #ccc",
                  textAlign: "center",
                  verticalAlign: "middle",
                  borderRadius: "25%",
                  // fontSize: 14,
                  cursor: "pointer",
                  transition: "0.2s",
                  fontFamily: "Stack Sans Headline, sans-serif",
                  background:
                    sheets && sheets[0]?.names[24] ? "#8CE4FF" : "#F08787",
                  // transform: "scale(1.03)",
                }}
              >
                <b style={{ fontSize: "25px", color: "#57595B" }}>
                  Ramadan 25 <br />
                </b>{" "}
                <span style={{ fontSize: "18px", color: "#57595B" }}>
                  February 17 | Tuesday
                </span>
                <br />
                <span style={{ fontSize: "22px", fontWeight: "bold" }}>
                  {sheets && sheets[0]?.names[24]
                    ? `${sheets[0]?.names[24]} | ${sheets[0]?.phones[24]}`
                    : "Available!"}
                  {/* {sheets && sheets[0]?.names[29]} |
                  {sheets && sheets[0]?.phones[29]} */}
                </span>
              </td>
            </tr>
            <tr>
              <td
                style={{
                  // width: 400,
                  // height: 30,
                  // border: "1px solid #ccc",
                  textAlign: "center",
                  verticalAlign: "middle",
                  borderRadius: "25%",
                  // fontSize: 14,
                  cursor: "pointer",
                  transition: "0.2s",
                  fontFamily: "Stack Sans Headline, sans-serif",
                  background:
                    sheets && sheets[0]?.names[1] ? "#8CE4FF" : "#F08787",
                  // transform: "scale(1.03)",
                }}
              >
                <b style={{ fontSize: "25px", color: "#57595B" }}>
                  Ramadan 2 <br />
                </b>{" "}
                <span style={{ fontSize: "18px", color: "#57595B" }}>
                  February 17 | Tuesday
                </span>
                <br />
                <span style={{ fontSize: "22px", fontWeight: "bold" }}>
                  {sheets && sheets[0]?.names[1]
                    ? `${sheets[0]?.names[1]} | ${sheets[0]?.phones[1]}`
                    : "Available!"}
                  {/* {sheets && sheets[0]?.names[29]} |
                  {sheets && sheets[0]?.phones[29]} */}
                </span>
              </td>
              <td
                style={{
                  // width: 400,
                  // height: 30,
                  // border: "1px solid #ccc",
                  textAlign: "center",
                  verticalAlign: "middle",
                  borderRadius: "25%",
                  // fontSize: 14,
                  cursor: "pointer",
                  transition: "0.2s",
                  fontFamily: "Stack Sans Headline, sans-serif",
                  background:
                    sheets && sheets[0]?.names[9] ? "#8CE4FF" : "#F08787",
                  // transform: "scale(1.03)",
                }}
              >
                <b style={{ fontSize: "25px", color: "#57595B" }}>
                  Ramadan 10 <br />
                </b>{" "}
                <span style={{ fontSize: "18px", color: "#57595B" }}>
                  February 17 | Tuesday
                </span>
                <br />
                <span style={{ fontSize: "22px", fontWeight: "bold" }}>
                  {sheets && sheets[0]?.names[9]
                    ? `${sheets[0]?.names[9]} | ${sheets[0]?.phones[9]}`
                    : "Available!"}
                  {/* {sheets && sheets[0]?.names[29]} |
                  {sheets && sheets[0]?.phones[29]} */}
                </span>
              </td>
              <td
                style={{
                  // width: 400,
                  // height: 30,
                  // border: "1px solid #ccc",
                  textAlign: "center",
                  verticalAlign: "middle",
                  borderRadius: "25%",
                  // fontSize: 14,
                  cursor: "pointer",
                  transition: "0.2s",
                  fontFamily: "Stack Sans Headline, sans-serif",
                  background:
                    sheets && sheets[0]?.names[17] ? "#8CE4FF" : "#F08787",
                  // transform: "scale(1.03)",
                }}
              >
                <b style={{ fontSize: "25px", color: "#57595B" }}>
                  Ramadan 18 <br />
                </b>{" "}
                <span style={{ fontSize: "18px", color: "#57595B" }}>
                  February 17 | Tuesday
                </span>
                <br />
                <span style={{ fontSize: "22px", fontWeight: "bold" }}>
                  {sheets && sheets[0]?.names[17]
                    ? `${sheets[0]?.names[17]} | ${sheets[0]?.phones[17]}`
                    : "Available!"}
                  {/* {sheets && sheets[0]?.names[29]} |
                  {sheets && sheets[0]?.phones[29]} */}
                </span>
              </td>
              <td
                style={{
                  // width: 400,
                  // height: 30,
                  // border: "1px solid #ccc",
                  textAlign: "center",
                  verticalAlign: "middle",
                  borderRadius: "25%",
                  // fontSize: 14,
                  cursor: "pointer",
                  transition: "0.2s",
                  fontFamily: "Stack Sans Headline, sans-serif",
                  background:
                    sheets && sheets[0]?.names[25] ? "#8CE4FF" : "#F08787",
                  // transform: "scale(1.03)",
                }}
              >
                <b style={{ fontSize: "25px", color: "#57595B" }}>
                  Ramadan 26 <br />
                </b>{" "}
                <span style={{ fontSize: "18px", color: "#57595B" }}>
                  February 17 | Tuesday
                </span>
                <br />
                <span style={{ fontSize: "22px", fontWeight: "bold" }}>
                  {sheets && sheets[0]?.names[25]
                    ? `${sheets[0]?.names[25]} | ${sheets[0]?.phones[25]}`
                    : "Available!"}
                  {/* {sheets && sheets[0]?.names[29]} |
                  {sheets && sheets[0]?.phones[29]} */}
                </span>
              </td>
            </tr>
            <tr>
              <td
                style={{
                  // width: 400,
                  // height: 30,
                  // border: "1px solid #ccc",
                  textAlign: "center",
                  verticalAlign: "middle",
                  borderRadius: "25%",
                  // fontSize: 14,
                  cursor: "pointer",
                  transition: "0.2s",
                  fontFamily: "Stack Sans Headline, sans-serif",
                  background:
                    sheets && sheets[0]?.names[2] ? "#8CE4FF" : "#F08787",
                  // transform: "scale(1.03)",
                }}
              >
                <b style={{ fontSize: "25px", color: "#57595B" }}>
                  Ramadan 3 <br />
                </b>{" "}
                <span style={{ fontSize: "18px", color: "#57595B" }}>
                  February 17 | Tuesday
                </span>
                <br />
                <span style={{ fontSize: "22px", fontWeight: "bold" }}>
                  {sheets && sheets[0]?.names[2]
                    ? `${sheets[0]?.names[2]} | ${sheets[0]?.phones[2]}`
                    : "Available!"}
                  {/* {sheets && sheets[0]?.names[29]} |
                  {sheets && sheets[0]?.phones[29]} */}
                </span>
              </td>
              <td
                style={{
                  // width: 400,
                  // height: 30,
                  // border: "1px solid #ccc",
                  textAlign: "center",
                  verticalAlign: "middle",
                  borderRadius: "25%",
                  // fontSize: 14,
                  cursor: "pointer",
                  transition: "0.2s",
                  fontFamily: "Stack Sans Headline, sans-serif",
                  background:
                    sheets && sheets[0]?.names[10] ? "#8CE4FF" : "#F08787",
                  // transform: "scale(1.03)",
                }}
              >
                <b style={{ fontSize: "25px", color: "#57595B" }}>
                  Ramadan 11 <br />
                </b>{" "}
                <span style={{ fontSize: "18px", color: "#57595B" }}>
                  February 17 | Tuesday
                </span>
                <br />
                <span style={{ fontSize: "22px", fontWeight: "bold" }}>
                  {sheets && sheets[0]?.names[10]
                    ? `${sheets[0]?.names[10]} | ${sheets[0]?.phones[10]}`
                    : "Available!"}
                  {/* {sheets && sheets[0]?.names[29]} |
                  {sheets && sheets[0]?.phones[29]} */}
                </span>
              </td>
              <td
                style={{
                  // width: 400,
                  // height: 30,
                  // border: "1px solid #ccc",
                  textAlign: "center",
                  verticalAlign: "middle",
                  borderRadius: "25%",
                  // fontSize: 14,
                  cursor: "pointer",
                  transition: "0.2s",
                  fontFamily: "Stack Sans Headline, sans-serif",
                  background:
                    sheets && sheets[0]?.names[18] ? "#8CE4FF" : "#F08787",
                  // transform: "scale(1.03)",
                }}
              >
                <b style={{ fontSize: "25px", color: "#57595B" }}>
                  Ramadan 19 <br />
                </b>{" "}
                <span style={{ fontSize: "18px", color: "#57595B" }}>
                  February 17 | Tuesday
                </span>
                <br />
                <span style={{ fontSize: "22px", fontWeight: "bold" }}>
                  {sheets && sheets[0]?.names[18]
                    ? `${sheets[0]?.names[18]} | ${sheets[0]?.phones[18]}`
                    : "Available!"}
                  {/* {sheets && sheets[0]?.names[29]} |
                  {sheets && sheets[0]?.phones[29]} */}
                </span>
              </td>
              <td
                style={{
                  // width: 400,
                  // height: 30,
                  // border: "1px solid #ccc",
                  textAlign: "center",
                  verticalAlign: "middle",
                  borderRadius: "25%",
                  // fontSize: 14,
                  cursor: "pointer",
                  transition: "0.2s",
                  fontFamily: "Stack Sans Headline, sans-serif",
                  background:
                    sheets && sheets[0]?.names[26] ? "#8CE4FF" : "#F08787",
                  // transform: "scale(1.03)",
                }}
              >
                <b style={{ fontSize: "25px", color: "#57595B" }}>
                  Ramadan 27 <br />
                </b>{" "}
                <span style={{ fontSize: "18px", color: "#57595B" }}>
                  February 17 | Tuesday
                </span>
                <br />
                <span style={{ fontSize: "22px", fontWeight: "bold" }}>
                  {sheets && sheets[0]?.names[26]
                    ? `${sheets[0]?.names[26]} | ${sheets[0]?.phones[26]}`
                    : "Available!"}
                  {/* {sheets && sheets[0]?.names[29]} |
                  {sheets && sheets[0]?.phones[29]} */}
                </span>
              </td>
            </tr>
            <tr>
              <td
                style={{
                  // width: 400,
                  // height: 30,
                  // border: "1px solid #ccc",
                  textAlign: "center",
                  verticalAlign: "middle",
                  borderRadius: "25%",
                  // fontSize: 14,
                  cursor: "pointer",
                  transition: "0.2s",
                  fontFamily: "Stack Sans Headline, sans-serif",
                  background:
                    sheets && sheets[0]?.names[3] ? "#8CE4FF" : "#F08787",
                  // transform: "scale(1.03)",
                }}
              >
                <b style={{ fontSize: "25px", color: "#57595B" }}>
                  Ramadan 4 <br />
                </b>{" "}
                <span style={{ fontSize: "18px", color: "#57595B" }}>
                  February 17 | Tuesday
                </span>
                <br />
                <span style={{ fontSize: "22px", fontWeight: "bold" }}>
                  {sheets && sheets[0]?.names[3]
                    ? `${sheets[0]?.names[3]} | ${sheets[0]?.phones[3]}`
                    : "Available!"}
                  {/* {sheets && sheets[0]?.names[29]} |
                  {sheets && sheets[0]?.phones[29]} */}
                </span>
              </td>
              <td
                style={{
                  // width: 400,
                  // height: 30,
                  // border: "1px solid #ccc",
                  textAlign: "center",
                  verticalAlign: "middle",
                  borderRadius: "25%",
                  // fontSize: 14,
                  cursor: "pointer",
                  transition: "0.2s",
                  fontFamily: "Stack Sans Headline, sans-serif",
                  background:
                    sheets && sheets[0]?.names[11] ? "#8CE4FF" : "#F08787",
                  // transform: "scale(1.03)",
                }}
              >
                <b style={{ fontSize: "25px", color: "#57595B" }}>
                  Ramadan 12 <br />
                </b>{" "}
                <span style={{ fontSize: "18px", color: "#57595B" }}>
                  February 17 | Tuesday
                </span>
                <br />
                <span style={{ fontSize: "22px", fontWeight: "bold" }}>
                  {sheets && sheets[0]?.names[11]
                    ? `${sheets[0]?.names[11]} | ${sheets[0]?.phones[11]}`
                    : "Available!"}
                  {/* {sheets && sheets[0]?.names[29]} |
                  {sheets && sheets[0]?.phones[29]} */}
                </span>
              </td>
              <td
                style={{
                  // width: 400,
                  // height: 30,
                  // border: "1px solid #ccc",
                  textAlign: "center",
                  verticalAlign: "middle",
                  borderRadius: "25%",
                  // fontSize: 14,
                  cursor: "pointer",
                  transition: "0.2s",
                  fontFamily: "Stack Sans Headline, sans-serif",
                  background:
                    sheets && sheets[0]?.names[19] ? "#8CE4FF" : "#F08787",
                  // transform: "scale(1.03)",
                }}
              >
                <b style={{ fontSize: "25px", color: "#57595B" }}>
                  Ramadan 20 <br />
                </b>{" "}
                <span style={{ fontSize: "18px", color: "#57595B" }}>
                  February 17 | Tuesday
                </span>
                <br />
                <span style={{ fontSize: "22px", fontWeight: "bold" }}>
                  {sheets && sheets[0]?.names[19]
                    ? `${sheets[0]?.names[19]} | ${sheets[0]?.phones[19]}`
                    : "Available!"}
                  {/* {sheets && sheets[0]?.names[29]} |
                  {sheets && sheets[0]?.phones[29]} */}
                </span>
              </td>
              <td
                style={{
                  // width: 400,
                  // height: 30,
                  // border: "1px solid #ccc",
                  textAlign: "center",
                  verticalAlign: "middle",
                  borderRadius: "25%",
                  // fontSize: 14,
                  cursor: "pointer",
                  transition: "0.2s",
                  fontFamily: "Stack Sans Headline, sans-serif",
                  background:
                    sheets && sheets[0]?.names[27] ? "#8CE4FF" : "#F08787",
                  // transform: "scale(1.03)",
                }}
              >
                <b style={{ fontSize: "25px", color: "#57595B" }}>
                  Ramadan 28 <br />
                </b>{" "}
                <span style={{ fontSize: "18px", color: "#57595B" }}>
                  February 17 | Tuesday
                </span>
                <br />
                <span style={{ fontSize: "22px", fontWeight: "bold" }}>
                  {sheets && sheets[0]?.names[27]
                    ? `${sheets[0]?.names[27]} | ${sheets[0]?.phones[27]}`
                    : "Available!"}
                  {/* {sheets && sheets[0]?.names[29]} |
                  {sheets && sheets[0]?.phones[29]} */}
                </span>
              </td>
            </tr>
            <tr>
              <td
                style={{
                  // border: "1px solid #ccc",
                  textAlign: "center",
                  verticalAlign: "middle",
                  borderRadius: "25%",
                  // fontSize: 14,
                  cursor: "pointer",
                  transition: "0.2s",
                  fontFamily: "Stack Sans Headline, sans-serif",
                  background:
                    sheets && sheets[0]?.names[4] ? "#8CE4FF" : "#F08787",
                  // transform: "scale(1.03)",
                }}
              >
                <b style={{ fontSize: "25px", color: "#57595B" }}>
                  Ramadan 5 <br />
                </b>{" "}
                <span style={{ fontSize: "18px", color: "#57595B" }}>
                  February 17 | Tuesday
                </span>
                <br />
                <span style={{ fontSize: "22px", fontWeight: "bold" }}>
                  {sheets && sheets[0]?.names[4]
                    ? `${sheets[0]?.names[4]} | ${sheets[0]?.phones[4]}`
                    : "Available!"}
                  {/* {sheets && sheets[0]?.names[29]} |
                  {sheets && sheets[0]?.phones[29]} */}
                </span>
              </td>
              <td
                style={{
                  // width: 400,
                  // height: 30,
                  // border: "1px solid #ccc",
                  textAlign: "center",
                  verticalAlign: "middle",
                  borderRadius: "25%",
                  // fontSize: 14,
                  cursor: "pointer",
                  transition: "0.2s",
                  fontFamily: "Stack Sans Headline, sans-serif",
                  background:
                    sheets && sheets[0]?.names[12] ? "#8CE4FF" : "#F08787",
                  // transform: "scale(1.03)",
                }}
              >
                <b style={{ fontSize: "25px", color: "#57595B" }}>
                  Ramadan 13 <br />
                </b>{" "}
                <span style={{ fontSize: "18px", color: "#57595B" }}>
                  February 17 | Tuesday
                </span>
                <br />
                <span style={{ fontSize: "22px", fontWeight: "bold" }}>
                  {sheets && sheets[0]?.names[12]
                    ? `${sheets[0]?.names[12]} | ${sheets[0]?.phones[12]}`
                    : "Available!"}
                  {/* {sheets && sheets[0]?.names[29]} |
                  {sheets && sheets[0]?.phones[29]} */}
                </span>
              </td>
              <td
                style={{
                  // width: 400,
                  // height: 30,
                  // border: "1px solid #ccc",
                  textAlign: "center",
                  verticalAlign: "middle",
                  borderRadius: "25%",
                  // fontSize: 14,
                  cursor: "pointer",
                  transition: "0.2s",
                  fontFamily: "Stack Sans Headline, sans-serif",
                  background:
                    sheets && sheets[0]?.names[20] ? "#8CE4FF" : "#F08787",
                  // transform: "scale(1.03)",
                }}
              >
                <b style={{ fontSize: "25px", color: "#57595B" }}>
                  Ramadan 21 <br />
                </b>{" "}
                <span style={{ fontSize: "18px", color: "#57595B" }}>
                  February 17 | Tuesday
                </span>
                <br />
                <span style={{ fontSize: "22px", fontWeight: "bold" }}>
                  {sheets && sheets[0]?.names[20]
                    ? `${sheets[0]?.names[20]} | ${sheets[0]?.phones[20]}`
                    : "Available!"}
                  {/* {sheets && sheets[0]?.names[29]} |
                  {sheets && sheets[0]?.phones[29]} */}
                </span>
              </td>
              <td
                style={{
                  // width: 400,
                  // height: 30,
                  // border: "1px solid #ccc",
                  textAlign: "center",
                  verticalAlign: "middle",
                  borderRadius: "25%",
                  // fontSize: 14,
                  cursor: "pointer",
                  transition: "0.2s",
                  fontFamily: "Stack Sans Headline, sans-serif",
                  background:
                    sheets && sheets[0]?.names[28] ? "#8CE4FF" : "#F08787",
                  // transform: "scale(1.03)",
                }}
              >
                <b style={{ fontSize: "25px", color: "#57595B" }}>
                  Ramadan 29 <br />
                </b>{" "}
                <span style={{ fontSize: "18px", color: "#57595B" }}>
                  February 17 | Tuesday
                </span>
                <br />
                <span style={{ fontSize: "22px", fontWeight: "bold" }}>
                  {sheets && sheets[0]?.names[28]
                    ? `${sheets[0]?.names[28]} | ${sheets[0]?.phones[28]}`
                    : "Available!"}
                  {/* {sheets && sheets[0]?.names[29]} |
                  {sheets && sheets[0]?.phones[29]} */}
                </span>
              </td>
            </tr>
            <tr>
              <td
                style={{
                  // width: 400,
                  // height: 30,
                  // border: "1px solid #ccc",
                  textAlign: "center",
                  verticalAlign: "middle",
                  borderRadius: "25%",
                  // fontSize: 14,
                  cursor: "pointer",
                  transition: "0.2s",
                  fontFamily: "Stack Sans Headline, sans-serif",
                  background:
                    sheets && sheets[0]?.names[5] ? "#8CE4FF" : "#F08787",
                  // transform: "scale(1.03)",
                }}
              >
                <b style={{ fontSize: "25px", color: "#57595B" }}>
                  Ramadan 6 <br />
                </b>{" "}
                <span style={{ fontSize: "18px", color: "#57595B" }}>
                  February 17 | Tuesday
                </span>
                <br />
                <span style={{ fontSize: "22px", fontWeight: "bold" }}>
                  {sheets && sheets[0]?.names[5]
                    ? `${sheets[0]?.names[5]} | ${sheets[0]?.phones[5]}`
                    : "Available!"}
                  {/* {sheets && sheets[0]?.names[29]} |
                  {sheets && sheets[0]?.phones[29]} */}
                </span>
              </td>
              <td
                style={{
                  // width: 400,
                  // height: 30,
                  // border: "1px solid #ccc",
                  textAlign: "center",
                  verticalAlign: "middle",
                  borderRadius: "25%",
                  // fontSize: 14,
                  cursor: "pointer",
                  transition: "0.2s",
                  fontFamily: "Stack Sans Headline, sans-serif",
                  background:
                    sheets && sheets[0]?.names[13] ? "#8CE4FF" : "#F08787",
                  // transform: "scale(1.03)",
                }}
              >
                <b style={{ fontSize: "25px", color: "#57595B" }}>
                  Ramadan 14 <br />
                </b>{" "}
                <span style={{ fontSize: "18px", color: "#57595B" }}>
                  February 17 | Tuesday
                </span>
                <br />
                <span style={{ fontSize: "22px", fontWeight: "bold" }}>
                  {sheets && sheets[0]?.names[13]
                    ? `${sheets[0]?.names[13]} | ${sheets[0]?.phones[13]}`
                    : "Available!"}
                  {/* {sheets && sheets[0]?.names[29]} |
                  {sheets && sheets[0]?.phones[29]} */}
                </span>
              </td>
              <td
                style={{
                  // width: 400,
                  // height: 30,
                  // border: "1px solid #ccc",
                  textAlign: "center",
                  verticalAlign: "middle",
                  borderRadius: "25%",
                  // fontSize: 14,
                  cursor: "pointer",
                  transition: "0.2s",
                  fontFamily: "Stack Sans Headline, sans-serif",
                  background:
                    sheets && sheets[0]?.names[21] ? "#8CE4FF" : "#F08787",
                  // transform: "scale(1.03)",
                }}
              >
                <b style={{ fontSize: "25px", color: "#57595B" }}>
                  Ramadan 22 <br />
                </b>{" "}
                <span style={{ fontSize: "18px", color: "#57595B" }}>
                  February 17 | Tuesday
                </span>
                <br />
                <span style={{ fontSize: "22px", fontWeight: "bold" }}>
                  {sheets && sheets[0]?.names[21]
                    ? `${sheets[0]?.names[21]} | ${sheets[0]?.phones[21]}`
                    : "Available!"}
                  {/* {sheets && sheets[0]?.names[29]} |
                  {sheets && sheets[0]?.phones[29]} */}
                </span>
              </td>
              <td
                style={{
                  // width: 400,
                  // height: 30,
                  // border: "1px solid #ccc",
                  textAlign: "center",
                  verticalAlign: "middle",
                  borderRadius: "25%",
                  // fontSize: 14,
                  cursor: "pointer",
                  transition: "0.2s",
                  fontFamily: "Stack Sans Headline, sans-serif",
                  background:
                    sheets && sheets[0]?.names[29] ? "#8CE4FF" : "#F08787",
                  // transform: "scale(1.03)",
                }}
              >
                <b style={{ fontSize: "25px", color: "#57595B" }}>
                  Ramadan 30 <br />
                </b>{" "}
                <span style={{ fontSize: "18px", color: "#57595B" }}>
                  February 17 | Tuesday
                </span>
                <br />
                <span style={{ fontSize: "22px", fontWeight: "bold" }}>
                  {sheets && sheets[0]?.names[29]
                    ? `${sheets[0]?.names[29]} | ${sheets[0]?.phones[29]}`
                    : "Available!"}
                  {/* {sheets && sheets[0]?.names[29]} |
                  {sheets && sheets[0]?.phones[29]} */}
                </span>
              </td>
            </tr>
            <tr>
              <td
                style={{
                  // width: 400,
                  // height: 30,
                  // border: "1px solid #ccc",
                  textAlign: "center",
                  verticalAlign: "middle",
                  borderRadius: "25%",
                  // fontSize: 14,
                  cursor: "pointer",
                  transition: "0.2s",
                  fontFamily: "Stack Sans Headline, sans-serif",
                  background:
                    sheets && sheets[0]?.names[6] ? "#8CE4FF" : "#F08787",
                  // transform: "scale(1.03)",
                }}
              >
                <b style={{ fontSize: "25px", color: "#57595B" }}>
                  Ramadan 7 <br />
                </b>{" "}
                <span style={{ fontSize: "18px", color: "#57595B" }}>
                  February 17 | Tuesday
                </span>
                <br />
                <span style={{ fontSize: "22px", fontWeight: "bold" }}>
                  {sheets && sheets[0]?.names[6]
                    ? `${sheets[0]?.names[6]} | ${sheets[0]?.phones[6]}`
                    : "Available!"}
                  {/* {sheets && sheets[0]?.names[29]} |
                  {sheets && sheets[0]?.phones[29]} */}
                </span>
              </td>
              <td
                style={{
                  // width: 400,
                  // height: 30,
                  // border: "1px solid #ccc",
                  textAlign: "center",
                  verticalAlign: "middle",
                  borderRadius: "25%",
                  // fontSize: 14,
                  cursor: "pointer",
                  transition: "0.2s",
                  fontFamily: "Stack Sans Headline, sans-serif",
                  background:
                    sheets && sheets[0]?.names[14] ? "#8CE4FF" : "#F08787",
                  // transform: "scale(1.03)",
                }}
              >
                <b style={{ fontSize: "25px", color: "#57595B" }}>
                  Ramadan 15 <br />
                </b>{" "}
                <span style={{ fontSize: "18px", color: "#57595B" }}>
                  February 17 | Tuesday
                </span>
                <br />
                <span style={{ fontSize: "22px", fontWeight: "bold" }}>
                  {sheets && sheets[0]?.names[14]
                    ? `${sheets[0]?.names[14]} | ${sheets[0]?.phones[14]}`
                    : "Available!"}
                  {/* {sheets && sheets[0]?.names[29]} |
                  {sheets && sheets[0]?.phones[29]} */}
                </span>
              </td>
              <td
                style={{
                  // width: 400,
                  // height: 30,
                  // border: "1px solid #ccc",
                  textAlign: "center",
                  verticalAlign: "middle",
                  borderRadius: "25%",
                  // fontSize: 14,

                  cursor: "pointer",
                  transition: "0.2s",
                  fontFamily: "Stack Sans Headline, sans-serif",
                  background:
                    sheets && sheets[0]?.names[22] ? "#8CE4FF" : "#F08787",
                  // transform: "scale(1.03)",
                }}
              >
                <b style={{ fontSize: "25px", color: "#57595B" }}>
                  Ramadan 23 <br />
                </b>{" "}
                <span style={{ fontSize: "18px", color: "#57595B" }}>
                  February 17 | Tuesday
                </span>
                <br />
                <span style={{ fontSize: "22px", fontWeight: "bold" }}>
                  {sheets && sheets[0]?.names[22]
                    ? `${sheets[0]?.names[22]} | ${sheets[0]?.phones[22]}`
                    : "Available!"}
                  {/* {sheets && sheets[0]?.names[29]} |
                  {sheets && sheets[0]?.phones[29]} */}
                </span>
              </td>
              <td
                style={{
                  // width: 400,
                  // height: 30,
                  // border: "1px solid #ccc",
                  textAlign: "center",
                  verticalAlign: "middle",
                  borderRadius: "25%",
                  // fontSize: 14,
                  cursor: "pointer",
                  transition: "0.2s",
                  fontFamily: "Stack Sans Headline, sans-serif",
                  background:
                    sheets && sheets[0]?.names[23] ? "#8CE4FF" : "#F08787",
                  // transform: "scale(1.03)",
                }}
              ></td>
            </tr>
            <tr>
              <td
                style={{
                  // width: 400,
                  // height: 30,
                  // border: "1px solid #ccc",
                  textAlign: "center",
                  verticalAlign: "middle",
                  borderRadius: "25%",
                  // fontSize: 14,
                  cursor: "pointer",
                  transition: "0.2s",
                  fontFamily: "Stack Sans Headline, sans-serif",
                  background:
                    sheets && sheets[0]?.names[7] ? "#8CE4FF" : "#F08787",
                  // transform: "scale(1.03)",
                }}
              >
                <b style={{ fontSize: "25px", color: "#57595B" }}>
                  Ramadan 8 <br />
                </b>{" "}
                <span style={{ fontSize: "18px", color: "#57595B" }}>
                  February 17 | Tuesday
                </span>
                <br />
                <span style={{ fontSize: "22px", fontWeight: "bold" }}>
                  {sheets && sheets[0]?.names[7]
                    ? `${sheets[0]?.names[7]} | ${sheets[0]?.phones[7]}`
                    : "Available!"}
                  {/* {sheets && sheets[0]?.names[29]} |
                  {sheets && sheets[0]?.phones[29]} */}
                </span>
              </td>
              <td
                style={{
                  // width: 400,
                  // height: 30,
                  // border: "1px solid #ccc",
                  textAlign: "center",
                  verticalAlign: "middle",
                  borderRadius: "25%",
                  // fontSize: 14,
                  cursor: "pointer",
                  transition: "0.2s",
                  fontFamily: "Stack Sans Headline, sans-serif",
                  background:
                    sheets && sheets[0]?.names[15] ? "#8CE4FF" : "#F08787",
                  // transform: "scale(1.03)",
                }}
              >
                <b style={{ fontSize: "25px", color: "#57595B" }}>
                  Ramadan 16 <br />
                </b>{" "}
                <span style={{ fontSize: "18px", color: "#57595B" }}>
                  February 17 | Tuesday
                </span>
                <br />
                <span style={{ fontSize: "22px", fontWeight: "bold" }}>
                  {sheets && sheets[0]?.names[15]
                    ? `${sheets[0]?.names[15]} | ${sheets[0]?.phones[15]}`
                    : "Available!"}
                  {/* {sheets && sheets[0]?.names[29]} |
                  {sheets && sheets[0]?.phones[29]} */}
                </span>
              </td>
              <td
                style={{
                  // width: 400,
                  // height: 30,
                  // border: "1px solid #ccc",
                  textAlign: "center",
                  verticalAlign: "middle",
                  borderRadius: "25%",
                  // fontSize: 14,
                  cursor: "pointer",
                  transition: "0.2s",
                  fontFamily: "Stack Sans Headline, sans-serif",
                  background:
                    sheets && sheets[0]?.names[23] ? "#8CE4FF" : "#F08787",
                  // transform: "scale(1.03)",
                }}
              >
                <b style={{ fontSize: "25px", color: "#57595B" }}>
                  Ramadan 24 <br />
                </b>{" "}
                <span style={{ fontSize: "18px", color: "#57595B" }}>
                  February 17 | Tuesday
                </span>
                <br />
                <span style={{ fontSize: "22px", fontWeight: "bold" }}>
                  {sheets && sheets[0]?.names[23]
                    ? `${sheets[0]?.names[23]} | ${sheets[0]?.phones[23]}`
                    : "Available!"}
                  {/* {sheets && sheets[0]?.names[29]} |
                  {sheets && sheets[0]?.phones[29]} */}
                </span>
              </td>
              <td
                style={{
                  // width: 400,
                  // height: 30,
                  // border: "1px solid #ccc",
                  textAlign: "center",
                  verticalAlign: "middle",
                  borderRadius: "25%",
                  // fontSize: 14,
                  cursor: "pointer",
                  transition: "0.2s",
                  fontFamily: "Stack Sans Headline, sans-serif",
                  background:
                    sheets && sheets[0]?.names[23] ? "#8CE4FF" : "#F08787",
                  // transform: "scale(1.03)",
                }}
              ></td>
            </tr>
          </tbody>
        </table>

        {/* CSS styles in the same page */}
        <style>
          {`
          @import url('https://fonts.googleapis.com/css2?family=Stack+Sans+Headline:wght@200..700&display=swap');

         @import url('https://fonts.googleapis.com/css2?family=Mulish:ital,wght@0,200..1000;1,200..1000&display=swap');
          body{
          // background-color: #F4F754;
          background-color: white;
           font-family: "Stack Sans Headline", sans-serif;
          }
          .custom-table {
            width: 100%;
            // color: white;
            
            border-collapse: collapse;
            // margin-top: 20px;
            font-family: Arial, sans-serif;
          }
            
          .custom-table th, .custom-table td {
            border: 4px solid #ffffffff;
            // padding: 5px;
            text-align: center;
          }
          .custom-table th {
            // background-color: #4CAF50;
            color: white;
          }
          .custom-table tr:nth-child(even) {
            background-color: #ffffffff;
          }
          .custom-table tr:hover {
            background-color: #ddd;
          }
        `}
        </style>
      </div>
    </>
  );
}
